
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#ee0909" type="ball-atom" [fullScreen]="true">
    <p style="color: white"> cargando .... </p>
</ngx-spinner>
<div class="panel">
    <div class="row">
        <div class="container">
            <div class="col-sm-11">
                <img src="./assets/images/Elementos/Carruse01.jpg" class="carrucel" />

            </div>
        </div>
        <br>
    </div>

    <div class="row">
        <div class="container">
            <div class=" col-sm-12 leyenda3">
                <p>{{title}}</p>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="container">
            <div class="col-sm-1"></div>
            <div class="col-sm-10">
    <mat-form-field appearance="standard">
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" #input>
    </mat-form-field>
</div>
</div>
</div> 
    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" class="tableGenerales table table-striped table-bordered">
            <ng-container matColumnDef="cdEstandarCompetencia">
                <th mat-header-cell *matHeaderCellDef> CÓDIGO </th>
                <td mat-cell *matCellDef="let element" (click)="detalleByEst(element)"> {{element.cdEstandarCompetencia}} </td>          
            </ng-container>
            <ng-container matColumnDef="nivel">
                <th mat-header-cell *matHeaderCellDef> NIVEL </th>
                <td mat-cell *matCellDef="let element" (click)="detalleByEst(element)"> {{element.nivel}} </td>
            </ng-container>                      
            <ng-container matColumnDef="nbTituloEc">
                <th mat-header-cell *matHeaderCellDef> TÍTULO </th>
                <td mat-cell *matCellDef="let element" (click)="detalleByEst(element)"> {{element.nbTituloEc}} </td>
            </ng-container>
                <ng-container matColumnDef="comite">
                <th mat-header-cell *matHeaderCellDef> COMITÉ </th>
            <td mat-cell *matCellDef="let element" (click)="detalleByEst(element)"> {{element.comite}} </td>
            </ng-container>
            <ng-container matColumnDef="sector">
                <th mat-header-cell *matHeaderCellDef> SECTOR </th>
                <td mat-cell *matCellDef="let element" (click)="detalleByEst(element)"> {{element.sector}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator
                 showFirstLastButtons 
                 aria-label="Select page of periodic elements">
        </mat-paginator>
        <br>
    <!--<table mat-table [dataSource]="dataSource" class="mat-elevation-z8"> 
  
    
    <ng-container matColumnDef="cdEstandarCompetencia">
      <th mat-header-cell *matHeaderCellDef> CÓDIGO </th>
      <td mat-cell *matCellDef="let element" (click)="detalleByEst(element)"> {{element.cdEstandarCompetencia}} </td>
    </ng-container>
  
    
    <ng-container matColumnDef="nivel">
      <th mat-header-cell *matHeaderCellDef> NIVEL </th>
      <td mat-cell *matCellDef="let element" (click)="detalleByEst(element)"> {{element.nivel}} </td>
    </ng-container>
  
    
    <ng-container matColumnDef="nbTituloEc">
      <th mat-header-cell *matHeaderCellDef> TÍTULO </th>
      <td mat-cell *matCellDef="let element" (click)="detalleByEst(element)"> {{element.nbTituloEc}} </td>
    </ng-container>
    <ng-container matColumnDef="comite">
        <th mat-header-cell *matHeaderCellDef> COMITÉ </th>
        <td mat-cell *matCellDef="let element" (click)="detalleByEst(element)"> {{element.comite}} </td>
      </ng-container>
      <ng-container matColumnDef="sector">
        <th mat-header-cell *matHeaderCellDef> SECTOR </th>
        <td mat-cell *matCellDef="let element" (click)="detalleByEst(element)"> {{element.sector}} </td>
      </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>-->

</div>

</div>
<br>
<br>
<div class="panel panel-danger " *ngIf="detalle">
    <br>
    <div class="row">
        <div class="container">
            <div class="col-sm-5"></div>
            <div style="text-align: center;" class="col-sm-1">
                <button mat-button (click)="back()"><img src="./assets/images/icon/Atras.png"
                        class=" imagen" /></button>
            </div>
            <div style="text-align: center;" class="col-sm-1">
                <button mat-button (click)="home()"><img src="./assets/images/icon/Home.png" class=" imagen" /></button>
            </div>
        </div>
    </div>
    <br>
</div>
  